export default "__VITE_ASSET__DsJAd8XT__"